function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (theme, _ref) {
  var getColor = _ref.getColor;
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
        variant = _ref2.variant,
        numericPrefix = _ref2.numericPrefix,
        numericSuffix = _ref2.numericSuffix,
        color = _ref2.color,
        __internal__focus = _ref2.__internal__focus;
      var hasPrefix = variant === "numeric" && numericPrefix;
      var hasSuffix = variant === "numeric" && numericSuffix;
      switch (targetElement) {
        case "inputContainer":
          {
            return _objectSpread(_objectSpread({
              position: "relative",
              fontSize: theme.fontSizes[1],
              fontWeight: theme.fontWeights.light,
              lineHeight: theme.lineHeights[2],
              fontFamily: theme.fonts.body,
              color: theme.colors.black
            }, hasPrefix && {
              "::before": {
                content: "\"".concat(numericPrefix, "\""),
                position: "absolute",
                top: "13px",
                left: theme.space[4]
              }
            }), hasSuffix && {
              "::after": {
                content: "\"".concat(numericSuffix, "\""),
                position: "absolute",
                top: "13px",
                right: theme.space[4]
              }
            });
          }
        case "input":
          {
            var focusStyle = {
              outline: 0,
              borderRadius: theme.radii[0],
              boxShadow: theme.shadows.focus
            };
            return _objectSpread({
              boxSizing: "border-box",
              width: "100%",
              height: "48px",
              border: 0,
              margin: 0,
              paddingTop: 0,
              paddingBottom: 0,
              fontSize: "inherit",
              fontWeight: "inherit",
              lineHeight: "inherit",
              fontFamily: "inherit",
              color: "inherit",
              backgroundColor: getColor(color),
              paddingLeft: hasPrefix ? "calc(".concat(theme.space[4], " + ").concat(numericPrefix.length + 1, "ch)") : theme.space[4],
              paddingRight: hasSuffix ? "calc(".concat(theme.space[4], " + ").concat(numericSuffix.length + 1, "ch)") : theme.space[4],
              ":focus": focusStyle
            }, __internal__focus && focusStyle);
          }
        default:
          {
            return null;
          }
      }
    }
  };
});